import { render, staticRenderFns } from "./HcpHelp.vue?vue&type=template&id=296622f0&scoped=true&"
import script from "./HcpHelp.vue?vue&type=script&lang=js&"
export * from "./HcpHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296622f0",
  null
  
)

export default component.exports